<template>
  <section class="hero">
    <div class="hero__content container">
      <h1 class="hero__title --fade-in-up --delay-1" data-vertical-ivp-class="--animate">
        A Unique Opportunity in a Rare Gemstone
      </h1>
      <p class="hero__description --fade-in-up --delay-3" data-vertical-ivp-class="--animate">
        GEMXX Corp. (GEMZ) is a mine to market gemstone and jewelry producer specializing in the
        extremely rare gemstone, Ammolite. The gem’s value has increased more than 300% over the past 20 years
        and GEMXX has more than $600M in ammolite reserves, ready for market applications.
      </p>
      <cta class="--fade-in-up --delay-3" data-vertical-ivp-class="--animate"/>
    </div>
  </section>
  <section class="hero__footer">
    <div class="container">
      <div class="hero__footer-cont --fade-in-left" data-vertical-ivp-class="--animate">
        <a href="https://www.gemxx.com/20best" target="_blank">
          Global Business Leaders Mag | Community for business professionals <br>
          GEMXX Corporation : The Pioneer of The Ammolite Industry </a>
      </div>
      <div class="hero__footer-cont --fade-in-left --delay-4" data-vertical-ivp-class="--animate">
        <a href="https://www.nationaljeweler.com/articles/831-5-things-to-know-about-ammolite" target="_blank">
          5 Things to Know About Ammolite</a>
      </div>
    </div>
    <div class="press-releases container">
      <h1 class="--fade-in-up" data-vertical-ivp-class="--animate">Latest Press Releases</h1>
      <h2 class="press-releases__article --fade-in-up --delay-1" data-vertical-ivp-class="--animate">
        <a href="https://www.gemxx.com/post/gemxx-corporation-purchases-50-equity-stake-in-gold-bearing-assets-in-british-columbia-canada" target="_blank">
          <b>March 13th, 2023</b>
          GEMXX Corporation purchases 50% equity stake in gold bearing assets in British Columbia, Canada
        </a>
      </h2>
      <h2 class="press-releases__article --fade-in-up --delay-2" data-vertical-ivp-class="--animate">
        <a href="https://www.gemxx.com/post/gemxx-corporation-posts-positive-quarterly-results-of-operations-and-gives-corporate-update" target="_blank">
          <b>February 28th, 2023</b>
          GEMXX Corporation  posts positive quarterly results of operations and gives corporate update
        </a>
      </h2>
      <h2 class="press-releases__article --fade-in-up --delay-3" data-vertical-ivp-class="--animate">
        <a href="https://www.gemxx.com/post/gemxx-corporation-announces-full-qualification-of-tier-1-form-1a-registration-statement" target="_blank">
          <b>February 1st, 2023</b>
          GEMXX Corporation announces full qualification of tier 1 - Form 1A registration statement
        </a>
      </h2>
      <h2 class="press-releases__article --fade-in-up --delay-4" data-vertical-ivp-class="--animate">
        <a href="https://www.gemxx.com/post/gemxx-corporation-solidifies-positive-annual-revenues-and-updates-shareholders-on-financial-results" target="_blank">
          <b>June 8th, 2022</b>
          GEMXX Posts Positive Financial
        </a>
      </h2>
    </div>
  </section>
</template>

<script>
import cta from '@/components/cta.vue';

export default {
  name: 'Hero',
  components: {
    cta
  },
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/hero.scss";
</style>
